// The heading font's ™ glyph renders thin even at heavy weights.
// When a ™ sits in bold text, swap it for "TM" letters styled as a superscript (.tm in custom.css)
// so it picks up the surrounding weight.
(function () {
  const SKIP = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION']);
  const BOLD = 600;

  function isBold(el) {
    return parseInt(getComputedStyle(el).fontWeight, 10) >= BOLD;
  }

  function replaceInNode(textNode) {
    const parent = textNode.parentElement;
    if (!parent || SKIP.has(parent.tagName) || parent.isContentEditable || !isBold(parent)) return;

    const parts = textNode.nodeValue.split('™');
    const fragment = document.createDocumentFragment();
    parts.forEach((part, i) => {
      if (part) fragment.appendChild(document.createTextNode(part));
      if (i < parts.length - 1) {
        const tm = document.createElement('span');
        tm.className = 'tm';
        tm.textContent = 'TM';
        fragment.appendChild(tm);
      }
    });
    parent.replaceChild(fragment, textNode);
  }

  function process(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      if (root.nodeValue.includes('™')) replaceInNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => (node.nodeValue.includes('™') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceInNode);
  }

  function init() {
    process(document.body);
    // Catch content added later (sliders, quick add, section rendering).
    new MutationObserver((mutations) => {
      mutations.forEach((m) => m.addedNodes.forEach(process));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
